import { useEffect, useState } from 'preact/hooks'
import { AccessibleToggleGroup } from '../dispatch/toggle-group'
import { PreactView } from '../preact-view'
import styles from './stock-taking-items-filter.module.css'

export const StockTakingItemsFilterView = PreactView.extend({
  component: StockTakingItemsFilter
})

type SortOrder = 'sortPosition' | 'name'

function StockTakingItemsFilter({ model }: { model: unknown }) {
  const [sortOrder, setSortOrder] = useState<SortOrder>('name')
  const [query, setQuery] = useState('')

  useEffect(() => {
    /** @file stock-taking-item-collection.js */
    // @ts-expect-error
    model.items.sortBy(sortOrder)
  }, [sortOrder])

  useEffect(() => {
    /** @file stock-taking-item-collection.js */
    // @ts-expect-error
    model.items.byName(query)
  }, [query])

  return (
    <div className={styles.filters}>
      <div class='input-addon'>
        <i class='icon ion-ios-search-strong input-addon-item' />

        <input
          className={styles.searchInput}
          type='text'
          name='product-search'
          autoComplete='off'
          autoCorrect='off'
          autoCapitalize='off'
          enterKeyHint='search'
          placeholder='Produkt suchen...'
          value={query}
          onKeyDown={(event) => {
            if (event.key === 'Escape' && query.length > 0) {
              event.stopPropagation()
              setQuery('')
            }
          }}
          onChange={(event) => setQuery(event.currentTarget.value)}
        />

        <button
          type='button'
          class={styles.resetSearchButton}
          onClick={() => setQuery('')}
        >
          <i class='icon ion-close' />
        </button>
      </div>

      <AccessibleToggleGroup<SortOrder>
        label='Sortieren:'
        options={[
          { value: 'sortPosition', label: 'Manuell' },
          { value: 'name', label: 'A-Z' }
        ]}
        value={sortOrder}
        onChange={setSortOrder}
      />
    </div>
  )
}
